// extracted by mini-css-extract-plugin
var _1 = "add-Za_xL";
export { _1 as "add" }
